import IGif from '@giphy/js-types/dist/gif'

const gpsTag = 'hashtag'

const HoverOverlay = ({ gif }: { gif: IGif }) => {
    console.log(gif)
    // const gpsTag = gif.gps_tags ? gif.gps_tags[0] : null

    return (
        <div>
            {gpsTag && (
                <a
                    href={'/edit/gifs?query=' + encodeURIComponent(gpsTag)}
                    onClick={(e) => {
                        e.preventDefault()
                        e.stopPropagation()
                        location.href = '/edit/gifs?query=' + encodeURIComponent(gpsTag)
                    }}
                    className="bg-[#121212] rounded-full h-9 leading-9 text-[#00FF99] font-bold italic text-[15px] inline-block absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 px-[18px] max-w-full whitespace-nowrap text-ellipsis overflow-hidden"
                    style={{ letterSpacing: 0 }}
                >
                    #{gpsTag}
                </a>
            )}
        </div>
    )
}

export default HoverOverlay
